import { render } from "./Index.vue?vue&type=template&id=8a298d30&scoped=true"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-8a298d30"

export default script